import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNuclearPowerPlant: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNuclearPowerPlant"><Path fillRule="evenodd" clipRule="evenodd" d="M5.20048 3H17.5772L17.6308 3.6921C17.8375 6.36121 18.0561 8.63889 18.3978 10.8295C20.5756 11.9915 21.9981 14.2708 21.9981 17V21H1.69141L2.04015 20.0025C4.10772 14.0886 4.66038 9.97468 5.14689 3.6921L5.20048 3ZM9.68657 15.5H20.3097C19.693 13.1327 17.6231 11.5 14.9981 11.5C12.3732 11.5 10.3033 13.1327 9.68657 15.5ZM20.4981 17H9.49814V19.5H20.4981V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNuclearPowerPlant;
